import { render, staticRenderFns } from "./RatePlanMappingItem.vue?vue&type=template&id=4b527644&scoped=true&"
import script from "./RatePlanMappingItem.vue?vue&type=script&lang=js&"
export * from "./RatePlanMappingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b527644",
  null
  
)

export default component.exports